<div class="wrapper">
  <div class="container-fluid">
    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item"><a href="javascript: void(0);" routerLink="/management/report">Report management</a></li>
              <li class="breadcrumb-item active" *ngIf="!!id">Edit merchant</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!-- end page title *ngIf="!id" -->
    <div class="row">
      <div class="col-12">
        <div class="card-box">

          <form class="form-horizontal" role="form" autocomplete="off">

            <div class="row" *ngIf="raiseWarning">
              <div class="col-md-12 form-horizontal px-3">
                <ngb-alert [dismissible]="false">
                  <strong>Warning!</strong> {{warning}}
                </ngb-alert>
              </div>
            </div>

            <div class="row" *ngIf="raiseDanger">
              <div class="col-md-12 form-horizontal px-3">
                <ngb-alert type="danger" [dismissible]="false">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>

            <div class="row form-horizontal" style="display:none">

              <div class="col-md-6 form-horizontal px-3">

                <div class="form-group row border-bottom my-3">
                  <label class="col-3 col-form-label font-weight-bold">Manage users </label>
                </div>

                <div class="form-group row" style="display: none">
                  <label for="Participant" class="col-3 col-form-label">Select a participant</label>
                  <div class="col-9">
                    <ng-select bindLabel="participant" style="width: 100%;" [(ngModel)]="selectedParticipantId" [ngModelOptions]="{standalone: true}" (click)="participantChange()" [clearable]="false" [searchable]="true">
                    </ng-select>
                  </div>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col-12">

                <div class="card-box">
                  <h4 class="header-title">User Report Setup</h4>
                  <p class="sub-header">
                    Link user profile to a merchant
                  </p>

                  <div class="form-group row">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                      <thead>
                        <tr>
                          <th>Username</th>
                          <th>Name</th>
                          <th>Active</th>
                          <th>Last login</th>
                          <th class="text-right">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let user of allUsers">
                          <td>{{ user.email }} </td>
                          <td>{{ user.name }} </td>
                          <td>
                            <i class="mdi mdi-check table-icon" *ngIf="!!user.isActive"></i>
                            <i class="mdi mdi-close table-icon" *ngIf="!user.isActive"></i>
                          </td>
                          <td>{{ user.lastLogin | date }} </td>
                          <td>
                            <button type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="manageUser(user)">
                              <i class="mdi mdi-content-save-edit-outline"></i>
                              manage
                            </button>
                          </td>
                        </tr>
                      </tbody>
                      <tbody *ngIf="allUsers?.length == 0">
                        <tr>
                          <td colspan="3" class="no-data-available">No users available!</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>
